import {AlertCircleIcon, TriangleAlertIcon, CircleCheckBigIcon} from 'lucide-react';
import {NotificationLevel} from '../../data/general/notificationLevel.enum';

export type IconType =
	| typeof CircleCheckBigIcon
	| typeof AlertCircleIcon
	| typeof TriangleAlertIcon;

export interface NotificationConfig {
	severity: 'success' | 'info' | 'warning' | 'error' | 'destroy';
	className: string;
	IconComponent: IconType;
	title: string;
}

export const prepareNotification = (level: NotificationLevel): NotificationConfig => {
	switch (level) {
		case NotificationLevel.SUCCESS:
			return {
				severity: 'success',
				className: 'bg-success text-white',
				IconComponent: CircleCheckBigIcon,
				title: 'Success!',
			};
		case NotificationLevel.ERROR:
			return {
				severity: 'error',
				className: 'bg-error text-white',
				IconComponent: AlertCircleIcon,
				title: 'Error',
			};
		case NotificationLevel.INFORMATION:
			return {
				severity: 'info',
				className: 'bg-info-notify text-blue-700',
				IconComponent: AlertCircleIcon,
				title: 'Info',
			};
		case NotificationLevel.WARNING:
			return {
				severity: 'warning',
				className: 'bg-warning text-white',
				IconComponent: TriangleAlertIcon,
				title: 'Warning',
			};
		case NotificationLevel.DESTROY:
			return {
				severity: 'destroy',
				className: 'bg-warning text-white',
				IconComponent: TriangleAlertIcon,
				title: 'Destroy',
			};
		default:
			return {
				severity: 'info',
				className: '',
				IconComponent: AlertCircleIcon,
				title: '',
			};
	}
};
